/**
 * Source unique de la palette d'accent de l'application.
 *
 * Avant ce fichier, trois bleus différents cohabitaient : `#1890ff` (défaut
 * Ant Design), `#0ea5e9` (ancienne échelle `primary` de Tailwind, teinte sky)
 * et `#2563eb` (bleu de la landing page et du menu). Tout est désormais aligné
 * sur l'échelle `blue` de Tailwind, dont `#2563eb` est le niveau 600.
 *
 * À utiliser partout où une couleur d'accent doit être écrite en JavaScript
 * (styles en ligne, options de graphiques, thème Ant Design). Dans le JSX,
 * préférer les classes utilitaires `primary-*`, qui pointent sur la même
 * échelle via `tailwind.config.js`.
 *
 * ⚠️ Ne pas utiliser ces valeurs pour des couleurs porteuses d'information
 * (statuts de commande, types de produit) : elles ont leur propre palette et
 * doivent rester distinctes les unes des autres.
 */

/** Échelle d'accent complète (identique à `theme.extend.colors.primary`). */
export const PRIMARY = {
  50: '#eff6ff',
  100: '#dbeafe',
  200: '#bfdbfe',
  300: '#93c5fd',
  400: '#60a5fa',
  500: '#3b82f6',
  600: '#2563eb',
  700: '#1d4ed8',
  800: '#1e40af',
  900: '#1e3a8a',
};

/** Accent par défaut : utilisé pour les actions, icônes et valeurs mises en avant. */
export const PRIMARY_COLOR = PRIMARY[600];

export default PRIMARY;
